var Curriculog = Curriculog || {};

Curriculog.AllProposalsAdminQueryParams = (function ($, _, Backbone, AllProposalsAdminQueryParams) {

	AllProposalsAdminQueryParams = Curriculog.QueryParams.extend({
		defaults: function() {
			return {
				entity: 0,
				includeEntityChildren: 0,
				ap: 0,
				currentStep: {},
				type: '',
				launchedDateRange: {},
				completedDateRange: {},
				exportedDateRange: {},
				originator: 0,
				status: ['reviewing','active','held','suspended','cancelled','waiting'],
				name: '',
				permission: '',
				deadline: 0,
				empty: 0,
				flag: '',
				decision: [],
				showCrosslisting: 1
			};
		},

		getDefaultParams: function() {
			var defaults = this.defaults();
			return defaults;
		},

		allowedStatuses: function() {
			var statusList = this.defaults().status;
			statusList.push('completed');
			return statusList;
		},

		allowedEmpty: function() {
			return true;
		},

		allowedFlag: function() {
			return true;
		},

		allowedDeadline: function() {
			return false;
		}

	});

	return AllProposalsAdminQueryParams;

})($, _, Backbone, Curriculog.AllProposalsAdminQueryParams || {});